import { render, staticRenderFns } from "./PraticaAutotrasporto.vue?vue&type=template&id=5e7c0ddc&"
import script from "./PraticaAutotrasporto.vue?vue&type=script&lang=js&"
export * from "./PraticaAutotrasporto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e7c0ddc')) {
      api.createRecord('5e7c0ddc', component.options)
    } else {
      api.reload('5e7c0ddc', component.options)
    }
    module.hot.accept("./PraticaAutotrasporto.vue?vue&type=template&id=5e7c0ddc&", function () {
      api.rerender('5e7c0ddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaAutotrasporto.vue"
export default component.exports